var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 29,
  height: 29,
  rx: 14.5,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.73548 10.5109C2.14449 10.5563 2.09903 11.3957 2.66729 11.5318L15.5327 14.5038C16.5329 12.099 16.5556 9.9664 14.8508 9.46729L2.73548 10.5109Z",
  fill: "url(#paint0_linear_450_2376)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.1735 8.47025C26.6508 8.42487 26.9236 9.01473 26.5826 9.35503L12.7398 22.831C12.3306 23.2394 11.6715 22.763 11.8988 22.2412L15.5129 14.505C16.513 12.1001 16.5358 9.99027 14.831 9.46847L26.1735 8.47025Z",
  fill: "url(#paint1_linear_450_2376)"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_450_2376",
  x1: 6.84336,
  y1: 15.1106,
  x2: 13.0338,
  y2: 7.71897,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.1155,
  stopColor: "#EA4403"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2632,
  stopColor: "#EA4A03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4566,
  stopColor: "#EC5A03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#EE7203"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7747,
  stopColor: "#F18402"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F8AE00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_450_2376",
  x1: 12.5123,
  y1: 15.1268,
  x2: 26.1095,
  y2: 16.3186,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.1155,
  stopColor: "#EA4403"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2356,
  stopColor: "#EA4A03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3928,
  stopColor: "#EC5A03"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#EE7203"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6535,
  stopColor: "#F18402"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8604,
  stopColor: "#F9B301"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.9959,
  stopColor: "#FFD500"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD500"
})));

var SvgAsLogo = function SvgAsLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAsLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/as-logo.43e819d8.svg";
export { ForwardRef as ReactComponent };